<template>
  <div>
    <CreativeTests
      discovery
      :brand="brand"
      @openTutorialModal="$emit('openTutorialModal')"
    />
  </div>
</template>

<script>
import CreativeTests from '../creativeTests/CreativeTests.vue'

export default {
  name: 'CreativeTestsBrandView',
  components: {
    CreativeTests
  },
  props: {
    brand: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.custom-bg {
  background-color: #F6F8FA;
}
</style>
